import { graphql } from "~/gql";

export const DATA_IMPORT_RECORDS_QUERY = graphql(/* GraphQL */ `
  query DataImportRecords($input: DataImportRecordsInput!) {
    dataImportRecordsQuery(input: $input) {
      items {
        entityType
        createdAt
        createdCount
        updatedCount
        deletedCount
        errorMessage
      }
      total
      page
      pageSize
    }
  }
`);
